<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" v-slot:default="{ loading, error, retry }">
    <card-loading v-if="loading" />
    <card-reload v-else-if="error" @reload="retry()"/>
    <procedures-stats-periods v-else :report="report" />
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import CardLoading from '@/components/dashboard/CardLoading.vue'
import CardReload from '@/components/dashboard/CardReload.vue'
import ProceduresStatsPeriods from '@/components/dashboard/efficiency/cards/ProceduresStatsPeriods.vue'
import { senseMap } from '@/plugins/colors.js'

export default {
  components: {
    ReportDataProvider,
    CardLoading,
    CardReload,
    ProceduresStatsPeriods
  },
  data () {
    return {
      requiredReports: ['tendersCount'],
      reports: null
    }
  },
  computed: {
    report () {
      return {
        title: 'Количество новых конкурсов',
        subtitle: 'детализировано за период',
        unit: 'шт.',
        plotConfig: this.plotConfig,
        stack: this.stack,
        line: this.line,
        legend: this.legend
      }
    },
    legend () {
      return [
        { label: 'C победителем', color: senseMap.winner },
        { label: 'Несостоявшиеся', color: senseMap.canceled },
        { label: 'Незавершенные', color: senseMap.incomplete },
        { label: 'Динамика открытия новых конкурсов', color: senseMap.new }
      ]
    },
    line () {
      const { newDynamicsByPeriod } = this.reports.tendersCount
      const series = newDynamicsByPeriod.map((val, i) => ({
        x: i, y: val
      }))
      return {
        series,
        style: {
          color: senseMap.new
        }
      }
    },
    stack () {
      const { canceledByPeriod, incompleteByPeriod, withWinnerByPeriod } = this.reports.tendersCount
      const data = withWinnerByPeriod.map((val, i) => ({
        x: i,
        top: [{ value: val, color: senseMap.winner }],
        bot: [{ value: canceledByPeriod[i], color: senseMap.canceled }, { value: incompleteByPeriod[i], color: senseMap.incomplete }]
      }))
      return data
    },
    plotConfig () {
      const { withWinnerByPeriod } = this.reports.tendersCount
      const labels = withWinnerByPeriod.map((_v, i) => ({ value: i, label: this.label(i) }))
      return {
        grid: {
          vertical: false,
          horizontal: false
        },
        axis: {
          x: labels,
          hidden: {
            y: true
          }
        },
        chartArea: {
          x: 5, y: 0, width: 90, height: 100
        }
      }
    }
  },
  methods: {
    label (offset) {
      return this.$store.getters['dashboard/label'](offset)
    }
  }
}
</script>
